import './index.scss';
import Nav from 'components/Nav';
import ProductItem from 'components/ProductItem';
import {observer, inject} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    sqtqd: store.sqtqd,
    tabClick: store.tabClick,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class AroundSummer extends React.Component {
    tabClick(keyName, index) {
        this.props.tabClick('sqtqd', keyName, index);
    }
    getTypeValue(data) {
        let dpj = '', lvj = '', result;
        result = data.filter(v => {
            if(v.display === undefined && !v.display.includes('mobile_list')) {
                return false;
            }
            if(v.tag_type === 'shopAllianceCoupon' && v.type === 'sales') {
                !dpj && v.amount && (dpj = (v.reduce_type === 1 ? '每满' : '满') + v.amount + '减' + v.reduce); // 店铺券
                return false;
            }
            if(v.tag_type === 'promotion' && v.type === 'sales') {
                !lvj && v.money && (lvj = '最高 满' + v.money + '减' + v.reduce); // 旅行券
                return false;
            }
            return true;
        });

        let dataSum = [];
        result = result.filter((t) => {
            if(dataSum.includes(t.title)) return false;
            dataSum.push(t.title);
            return true;
        });
        return {
            dpj,
            lvj,
            result
        };
    }
    pRend(data) {
        const {ymbj} = this.props;
        let tags = data.data.tags ? data.data.tags : [];
        const promoteDesc = ymbj.promoteDesc;

        let dpjContent = '', lvjContent = '';
        if(data.tagInfos) {
            let {result, dpj, lvj} = this.getTypeValue(data.tagInfos, 'tag_type', 'shopAllianceCoupon', 'title');
            dpjContent = dpj;
            lvjContent = lvj;
            !tags.length && (tags = result);
        }
        return (
            <div className="pro-info ">
                <div className="tit">{data.title}</div>
                <div className="tags lr-tags">
                    {
                        data.data && data.data.desc ? <div className="des">{data.data.desc}</div> :
                            tags.map((item) => {
                                const text = item.tag || item.title;
                                if(!text) return null;
                                return <div className="tags-item">{text}</div>;
                            })
                    }
                </div>
                <div className="dpmj-item">
                    瓜分可得
                    <span className="line"></span>
                    {lvjContent ? lvjContent : promoteDesc}
                </div>
                <div className={`${dpjContent ? 'dpmj-item': 'empty-item'}`}>
                    {
                        dpjContent ?
                            <div>
                                店铺劵
                                <span className="line"></span>
                                {dpjContent}
                            </div> : ''
                    }
                </div>
                <div className="price-info">
                    <div className="price lr-price">&yen;<span className="num">{data.taocanPrice ? data.taocanPrice : data.price}</span>起</div>
                    <div className={`btn ${data.status === 2 ? 'soldout' : 'lr-btn'}`} >{data.status === 2 ? '已售罄' : '立即购买'}</div>
                </div>
            </div>
        );
    }
    render() {
        const {sqtqd, jump} = this.props;
        const {sqtqdFirstTab, pros} = sqtqd;
        return (
            <div className="m-advancesummer m-floor" id="sqtqd">
                <ModuleTitle name="sqtqd"/>
                <Nav
                    tabs={sqtqdFirstTab}
                    tabClick={(keyName, index)=> {
                        this.tabClick(keyName, index);
                        sendSK('click_sqtqd_tab' + (index + 1));
                    }}
                    navCls="common-navitem"
                    navClsAct="common-navactive"
                    moreCls="common-navitem"
                    dbackCls="common-drawback"
                    keyName="sqtqdFirstTab"
                />
                {
                    pros.length ?
                        <div className="pro-lists">
                            {
                                pros.map((item, index) => {
                                    if(index > 5) return null;
                                    return <ProductItem
                                        custCls="lr-item"
                                        pRendeStatus={true}
                                        data={item}
                                        jump={() => {
                                            jump(item.jumpInfo, 'shuqi_sqtqd');
                                            sendSK('click_sqtqd', {
                                                floor: '暑期提前订',
                                                id: item.id
                                            });
                                        }} key={index}
                                        pRend={this.pRend.bind(this)}
                                    />;
                                })
                            }
                        </div> : ''
                }
            </div>
        );
    }
}

export default AroundSummer;